import OrdenesComprasScreen from "../../Screen/Compras/Ordenes/OrdenesComprasScreen";
import AprobarRequisasScreen from "../../Screen/Compras/Requisas/AprobarRequisas/AprobarRequisasScreen";
import LiberarBodegaScreen from "../../Screen/Compras/Requisas/LiberarRequisas/LiberarBodegaScreen";
import LiberarRequisasScreen from "../../Screen/Compras/Requisas/LiberarRequisas/LiberarRequisasScreen";
import PurchareRequestsScreen from "../../Screen/Compras/Requisas/PurchareRequestsScreen";
// import ProveedoresSceeen from "../../Screen/Compras/Proveedores/ProveedoresSceeen";
import ResumenComprasScreen from "../../Screen/Compras/ResumenCompras/ResumenComprasScreen"
import ProveedoresScreen from "../../Base/Screens/Proveedores/ProveedoresScreen"
import ListoProveedoresScreen from "../../Base/Screens/Proveedores/ListoProveedoresScreen"


import ResumenConsumoProductosScreen from '../../Base/Screens/Inventarios/BodegaMateriales/ResumenConsumoProductosScreen'
import RegistroFacturasScreen from '../../Base/Screens/Proveedores/CuentasPorPagar/RegistroFacturasScreen'
import RegistroFacturasMateriaPrimaScreen from '../../Base/Screens/Proveedores/CuentasPorPagar/FacturasMateriaPrima/RegistroFacturasMateriaPrimaScreen'
export const ComprasRoutes = [
    {
        path: 'Compras/RequisicionCompras/Requisa/Listado',
        permiso: 8,
        element: <PurchareRequestsScreen />
    },
    {
        path: 'Compras/OrdenCompras/Listado',
        permiso: 9,
        element: <OrdenesComprasScreen />
    },
    {
        path: 'Compras/LiberarRequisas',
        permiso: 10,
        element: <LiberarRequisasScreen />
    },
    {
        path: 'Compras/AprobarRequisas',
        permiso: 13,
        element: <AprobarRequisasScreen />
    },
    {
        path: 'Compras/Proveedores',
        permiso: 22,
        element: <ListoProveedoresScreen Finanzas={false}/>
    },
    {
        path: 'Compras/LiberarBodega',
        permiso: 48,
        element: <LiberarBodegaScreen />
    },
    {
        path: 'BodegaMateriales/ResumenConsumoProductos',
        permiso: 104,
        element: <ResumenConsumoProductosScreen IPS={true} />
    },
    {
        path: 'Compras/ResumenCompras',
        permiso: 14,
        element: <ResumenComprasScreen />
    },
    {
        path: 'Compras/RegistroFacturas',
        permiso: 111,
        element: <RegistroFacturasScreen />
    },
    {
        path: 'Compras/FacturasMateriaPrima',
        permiso: 136,
        element: <RegistroFacturasMateriaPrimaScreen />
    }


];

export default ComprasRoutes;